var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visibleVariation)?_c('div',[_c(_vm.cmsBlocksComponent,{key:_vm.featureFlag,tag:"component",attrs:{"blocks":_vm.visibleVariation.blocks}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }